export default __webpack_public_path__ + "static/media/logout_icon.0d879df4.svg";